import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

import './Blocker.css';

const Blocker = ({ glyph, height, icon, message, width, className }) => (
  <div className={`tvt-blocker ${className}`}>
    <div className="tvt-blocker__message" style={{ width, height }}>
      {icon && <img src={icon} alt="Blocker Icon" />}
      {glyph && <Glyphicon glyph={glyph} className="tvt-blocker__icon" />}
      <p className="tvt-blocker__message-content">{message}</p>
    </div>
  </div>
);

Blocker.propTypes = {
  className: PropTypes.string,
  glyph: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.string,
  message: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Blocker.defaultProps = {
  className: '',
  glyph: null,
  height: 280,
  icon: null,
  message: '',
  width: '100%'
};

export default Blocker;
